require('./bootstrap');

window.Swal = require('sweetalert2');

window.select2 = require('select2/dist/js/select2.min');
window.Chart = require('chart.js/dist/chart');

// Install AlpineJS
import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.start();